:host {
  display: block;

  a {
    text-decoration: none;
  }
}

.disturber {
  position: relative;
  font-family: var(--primary-font);
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  max-width: 1600px;
  min-height: 60px;
  margin: 0 auto;
  text-align: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 5px 15px;
  background: var(--color-bleached-silk);
  @media (min-width: 1024px) {
    min-height: 70px;
  }

  &.wishlist {
    display: flex;
    flex-direction: row;
    column-gap: 12px;
    margin: 60px 0 30px;
    padding: 24px;
    color: var(--color-nero);
    max-width: none;

    .disturber-text-wrapper {
      display: flex;
      flex-direction: column;

      .headline {
        text-align: left;
        font-size: 20px;
        line-height: 27px;
        font-weight: var(--font-weight-semibold);
        margin-bottom: 16px;
      }
    }

    lilu-icon {
      margin-top: 6px;
    }

    lilu-link {
      text-align: left;
    }
  }

  .headline {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 20px;
    font-weight: var(--font-weight-semibold);

    @include breakpointMin('lg') {
      font-size: 24px;
      font-weight: var(--font-weight-bold);
    }
  }

  .close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    min-width: 60px;
    height: 100%;
    cursor: pointer;

    @media (min-width: 1024px) {
      min-width: 70px;
    }

    &:hover {
      opacity: 0.7;
    }
  }
}
